import { faPrint } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@shared/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@shared/components/ui/dropdown-menu';
import { useTranslation } from 'react-i18next';
import {
  generatePackingStationLocationLabelsPdf,
  LabelSize,
} from '../../utils/generatePackingStationLocationLabelsPdf';

interface LocationLabelPrintMenuProps {
  codes: string[];
  variant?: 'icon' | 'button';
  dataTestId?: string;
}

export const LocationLabelPrintMenu = ({ codes, variant = 'icon', dataTestId }: LocationLabelPrintMenuProps) => {
  const { t } = useTranslation('packingStationsModule');

  const handlePrint = async (size: LabelSize) => {
    try {
      await generatePackingStationLocationLabelsPdf(codes, size);
    } catch (error) {
      console.error('Error generando PDF para ubicación:', error);
    }
  };

  if (codes.length === 0) return null;

  const trigger =
    variant === 'button' ? (
      <Button variant="outline" size="sm" type="button" className="gap-2" data-testid={dataTestId}>
        <FontAwesomeIcon icon={faPrint} className="h-3.5 w-3.5" />
        {t('detail.locations.printLabels')}
      </Button>
    ) : (
      <Button
        variant="ghost"
        size="sm"
        type="button"
        className="h-8 w-8 shrink-0 p-0"
        data-testid={dataTestId}
        onClick={(e) => e.stopPropagation()}
      >
        <FontAwesomeIcon icon={faPrint} className="h-3.5 w-3.5 text-icons" />
      </Button>
    );

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>{trigger}</DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-44 border-card-border">
        <DropdownMenuItem onClick={() => void handlePrint('small')}>{t('label.size_small')}</DropdownMenuItem>
        <DropdownMenuItem onClick={() => void handlePrint('large')}>{t('label.size_large')}</DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
